import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import React from 'react';
import { ReactComponent as DangerIcon } from 'assets/icons/danger-icon.svg';
import { CoKitchenType } from 'utils/types';

const ActivateKitchenModal = ({
  kitchen,
  show,
  onClose,
  onConfirm,
  loading,
  isChecked
}: {
  kitchen: CoKitchenType;
  show: boolean;
  onClose: () => void;
  loading: boolean;
  onConfirm: () => void;
  isChecked: boolean;
}) => {
  return (
    <BaseModal isOpen={show} title='' onRequestClose={() => onClose()} bodyOpenClassName=''>
      <div className='text-center'>
        <div className='flex justify-center'>
          <DangerIcon />
        </div>

        <h4 className='font-medium mt-2'>
          Turn {isChecked ? 'on' : 'off'} {kitchen.name} kitchen?
        </h4>
        <p className='text-[#858585] mt-2 mb-10'>
          Are you sure you want {kitchen.name} kitchen to be{' '}
          {isChecked ? 'activated' : 'de-activated'} ?
        </p>

        <div className='flex justify-between gap-4'>
          <Button small onClick={() => onClose()} color='gray' variant='block' className=''>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className='capitalize'
            color='primary'
            variant='block'
            loading={loading}
            small>
            Confirm
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default ActivateKitchenModal;
